import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 600px;
  border-radius: 24px;
  background: white;
`;

export const Header = styled.div`
  background-color: #ffffff;
  padding: 24px 24px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ShareIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const Title = styled.h1`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #1a1a1a;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
`;

export const CloseButton = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const DialogBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ItemBox = styled.div`
  background: #ffffff;
  border: 1px solid var(--color-neutral-alpha-90, #C9C6CC80);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  background:#F2F1F380;
  box-shadow: 0px 0px 4px 0px #00000040 inset;

  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 4px;
    
    &:hover {
      background: #b0b0b0;
    }
  }
`;

export const ItemIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ItemInfo = styled.div`
  flex: 1;
`;

export const ItemContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemTitle = styled.h3`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1a1a1a;
  margin: 0 0 4px 0;
`;

export const ItemSubtitle = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
  margin: 0;
`;

export const ItemTypeLabel = styled.span`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #000000;
  display: inline-block;
`;

export const ItemActions = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const ItemRemoveButton = styled.button`
  border: none;
  background: transparent;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemRemoveIcon = styled.img`
  width: 30px;
  height: 30px;
`;

export const SectionLabel = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1a1a1a;
  margin: 8px 0 0 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EmailInputContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border: 1px solid ${props => props.hasError ? '#EF4444' : '#d0d0d0'};
  border-radius: 8px;
  background: white;
  
  &:hover {
    border-color: ${props => props.hasError ? '#EF4444' : '#8B5CF6'};
  }
  
  &:focus-within {
    border-color: ${props => props.hasError ? '#EF4444' : '#8B5CF6'};
  }
`;

export const EmailInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  color: #1a1a1a;
  
  &::placeholder {
    color: #999999;
  }
`;
// Add button for shared resource section, design might change
export const AddButton = styled.button`
  background: none;
  border: none;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.disabled ? 0.5 : 1};
  
  &:hover {
    background-color: ${props => props.disabled ? 'transparent' : '#f3f3f3'};
  }
  
  img {
    width: 20px;
    height: 20px;
  }
`;

export const ErrorMessage = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 12px;
  color: #EF4444;
  margin-top: -8px;
  margin-bottom: 8px;
`;

export const SelectedEmailsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const EmailInitials = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${props => props.color || '#8B5CF6'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s ease;
  border: 2px solid white;
  margin-left: -12px;
  
  &:first-child {
    margin-left: 0;
  }
  
  &:hover {
    opacity: 0.8;
    z-index: 10;
  }
`;

export const EmailCloseIcon = styled.img`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  background: white;
  border-radius: 50%;
  padding: 2px;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.2);
  }
`;

export const ShareButton = styled.button`
  width: 100%;
  padding: 14px;
  background-color: ${props => props.disabled ? '#d0d0d0' : 'var(--color-purple-300, #7200E0)'};
  color: white;
  border: none;
  border-radius: 30px;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 16px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  margin-top: 16px;
  
  &:hover {
    background-color: ${props => props.disabled ? '#d0d0d0' : '#7C3AED'};
  }
`;

